import React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Box, Typography } from '@deere/fuel-react';


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#367c2b' : '#f2a900',
    },
}));


export const ProgressIndicator = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <BorderLinearProgress />
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                p={4}
            >
                <Typography
                    gutterBottom
                    variant="subtitle1"
                >
                    {"Loading Declaration File..."}
                </Typography>
                <Typography variant="subtitle2">
                    {"This will take a couple seconds"}
                </Typography>
            </Box>
        </Box>
    )
}